import React, { useEffect } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';

import { Themes, useTheme } from '../ThemeContext';
import { Flex } from '../components/Flex';
import { Content } from '../utils/local-antd';
import { PublicHeader } from './PublicHeader';

export const PublicLayout: React.FC = () => {
  const { currentTheme, toggleTheme } = useTheme();

  useEffect(() => {
    if (currentTheme === Themes.DARK) {
      toggleTheme();
    }
  }, [currentTheme, toggleTheme]);

  return (
    <Flex flexDirection="column" flexGrow={1}>
      <PublicHeader />
      <Content>
        <Outlet />
      </Content>
      <ScrollRestoration />
    </Flex>
  );
};
